import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import NaranciaSubHeader from '../parts/NaranciaSubHeader'
import Alert from 'react-s-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import AudioController from './AudioController'
import EditEditorModal from './EditEditorModal'
import NaranciaEditorBlock from './NaranciaEditorBlock'
import { _createStartTimes } from '../../../utils/Helper'
import axios from 'axios'
import { Player, BigPlayButton } from 'video-react';
import './video-react.css';

const Diff = require('diff');

// const THRESH1_DURATION = 25
// const THRESH1_PAUSE = 0.6
// const THRESH2_DURATION = 45
// const THRESH2_PAUSE = 0.3
// const THRESH3_DURATION = 60

const THRESH1_DURATION = 25
const THRESH1_PAUSE = 0.6
const THRESH2_DURATION = 30
const THRESH2_PAUSE = 0.3
const THRESH3_DURATION = 35








// get audio buffer from array buffer
let getAudioBufferFromArrayBuffer = (_arrayBuffer) => {
  return new Promise((resolve, reject) => {

    let audioContext = new AudioContext()

    // Convert array buffer into audio buffer
    audioContext.decodeAudioData(_arrayBuffer, (audioBuffer) => {
      resolve(audioBuffer)
    })
  })
}

// Returns Uint8Array of WAV bytes
function getWavBytes(buffer, options) {
  const type = options.isFloat ? Float32Array : Uint16Array
  const numFrames = buffer.byteLength / type.BYTES_PER_ELEMENT

  const headerBytes = getWavHeader(Object.assign({}, options, { numFrames }))
  const wavBytes = new Uint8Array(headerBytes.length + buffer.byteLength);

  // prepend header, then add pcmBytes
  wavBytes.set(headerBytes, 0)
  wavBytes.set(new Uint8Array(buffer), headerBytes.length)

  return wavBytes
}

// adapted from https://gist.github.com/also/900023
// returns Uint8Array of WAV header bytes
function getWavHeader(options) {
  const numFrames =      options.numFrames
  const numChannels =    options.numChannels || 2
  const sampleRate =     options.sampleRate || 44100
  const bytesPerSample = options.isFloat? 4 : 2
  const format =         options.isFloat? 3 : 1

  const blockAlign = numChannels * bytesPerSample
  const byteRate = sampleRate * blockAlign
  const dataSize = numFrames * blockAlign

  const buffer = new ArrayBuffer(44)
  const dv = new DataView(buffer)

  let p = 0

  function writeString(s) {
    for (let i = 0; i < s.length; i++) {
      dv.setUint8(p + i, s.charCodeAt(i))
    }
    p += s.length
  }

  function writeUint32(d) {
    dv.setUint32(p, d, true)
    p += 4
  }

  function writeUint16(d) {
    dv.setUint16(p, d, true)
    p += 2
  }

  writeString('RIFF')              // ChunkID
  writeUint32(dataSize + 36)       // ChunkSize
  writeString('WAVE')              // Format
  writeString('fmt ')              // Subchunk1ID
  writeUint32(16)                  // Subchunk1Size
  writeUint16(format)              // AudioFormat
  writeUint16(numChannels)         // NumChannels
  writeUint32(sampleRate)          // SampleRate
  writeUint32(byteRate)            // ByteRate
  writeUint16(blockAlign)          // BlockAlign
  writeUint16(bytesPerSample * 8)  // BitsPerSample
  writeString('data')              // Subchunk2ID
  writeUint32(dataSize)            // Subchunk2Size

  return new Uint8Array(buffer)
}






// NaranciaAnnotationSplit
const NaranciaAnnotationSplit = (props) => {


  // let editorPositionRef = useRef(null)

  // https://stackoverflow.com/questions/65350114/useref-for-element-in-loop-in-react
  let editorRefs = useRef([])

  let editorRef = useRef(null)
  let widthRef = useRef(null)
  let playerRef = useRef(null)

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false)
  let [transcriptDraftjsRaw, setTranscriptDraftjsRaw] = useState(null)
  let [transcriptDraftjsAI, setTranscriptDraftjsAI] = useState(null)
  let [isPlaying, setIsPlaying] = useState(false)
  // let [blockTimes, setBlockTimes] = useState([])
  let [playingBlockIndex, setPlayingBlockIndex] = useState(0)
  let [playerCurrentTime, setPlayerCurrentTime] = useState(0)
  let [mediaUrl, setMediaUrl] = useState("")
  let [playIconStartIndex, setPlayIconStartIndex] = useState(0)
  let [playIconStartTexts, setPlayIconStartTexts] = useState("")
  let [playIconStartDiff, setPlayIconStartDiff] = useState(null)
  let [playIconMarginTop, setPlayIconMarginTop] = useState(26)
  let [startTimes, setStartTimes] = useState([])

  let [apiKeyToTranscribe, setApiKeyToTranscribe] = useState("")
  let [apiKeyToAdd, setApiKeyToAdd] = useState("")
  let [naranciaId, setNaranciaId] = useState("")
  let [naranciaChecked, setNaranciaChecked] = useState(false)

  let [showEditEditor, setShowEditEditor] = useState(false)
  let [editorItem, setEditorItem] = useState(null)
  let [chunkList, setChunkList] = useState([])

  let [chunkByTimeList, setChunkByTimeList] = useState([])
  let [edittingIdx, setEdittingIdx] = useState(-1)

  let [shortAudio, setShortAudio] = useState(new Audio())

  // let [apiKey, setApiKey] = useState("83a389553cf41de009913298bef01beca01405df9f6f3a494bdb2cf138b9a976")
  // default api key
  let [apiKey, setApiKey] = useState("06a4f131079b6dfc9c0e10a721a4e59d6eba1e95f4622926654dcb34a8ed51bb")
  let [naranciaItem, setNaranciaItem] = useState(null)
  let [mediaType, setMediaType] = useState("audio")
  let [videoUrl, setVideoUrl] = useState("")
  let [tmpVideoUrl, setTmpVideoUrl] = useState("")

  // componentDidMount
  useEffect(() => {

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    let narancia_id = params._id
    if (!narancia_id) {
      // throw Error("no narancia_id detected.")
      return
    }

    setNaranciaId(narancia_id)

    let audio_url = "https://alphatest.shabelab.com/api/narancia_audio?_id="+narancia_id
    setMediaUrl(audio_url)
    console.log("audio_url: ", audio_url)


    // get narancia file data
    await _get_narancia_file_one({
      narancia_id: narancia_id,
    })


    // get chunk list
    await _get_chunks(narancia_id)
  }






  // get list
  let _get_narancia_file_one = async ({
    narancia_id,
  }) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.getNaranciaFileOne({
        login_token: login_token,
        narancia_id: narancia_id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      console.log("getNaranciaFileOne.results_1: ", results_1)

      if (results_1.item) {
        setNaranciaItem(results_1.item)

        if (results_1.item.type === "video") {
          setMediaType("video")

          let video_url = "https://alphatest.shabelab.com/api/narancia_video?_id="+narancia_id
          console.log("video_url: ", video_url)

          setVideoUrl(video_url)
        }
      }

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }









  // get chunk list
  let _get_chunks = async (narancia_id) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.getNaranciaChunks({
        login_token: login_token,
        narancia_id: narancia_id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      console.log("getNaranciaChunks.results_1: ", results_1)

      setChunkList(results_1.chunk_list)

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }








  //
  // Editor related...
  //

  // show alert
  let _showAlert = (_message) => {
    Alert.info(_message, {
      position: 'top-right',
      effect: 'slide',
      timeout: 5000
    });
  }

  // // set ypos and start time
  // let _setYPos = ({
  //   relativeY,
  //   texts,
  // }) => {
  //
  //   let domRect = editorPositionRef.current.getBoundingClientRect();
  //
  //   let _margin = relativeY - domRect.top + 4
  //
  //   setPlayIconMarginTop(_margin)
  //
  //   let _index = parseInt(_margin / 30)
  //
  //   setPlayIconStartIndex(_index)
  //   setPlayIconStartTexts(texts)
  // }

  // _transcript
  let _transcript = async (type) => {


    console.log("_transcript.type: ", type)

    setLoading(true)

    try {

      let urlSearchParams = new URLSearchParams(window.location.search);
      let params = Object.fromEntries(urlSearchParams.entries());
      let narancia_id = params._id
      if (!narancia_id) {
        throw Error("no narancia_id detected.")
      }

      // get evaluation masters
      const results_1 = await MyAPI.transcriptForNarancia({
        login_token: login_token,
        narancia_id: narancia_id,
        ai_api_key: apiKey,
        action_type: type,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      console.log("transcriptForNarancia.results_1.1: ", results_1)

      let transcript_draftjs_raw = ""
      if (results_1.transcript_draftjs_raw) {
        transcript_draftjs_raw = JSON.parse(results_1.transcript_draftjs_raw)
        setTranscriptDraftjsRaw(transcript_draftjs_raw)
      }

      // raw
      if (type === "trnscribe") {
        if (transcript_draftjs_raw) {

          setTranscriptDraftjsAI(transcript_draftjs_raw)

          // set block times ...
          let blocks = transcript_draftjs_raw.blocks

          // create start times
          let editor_width = 730
          if (widthRef.current) {
            editor_width = widthRef.current.offsetWidth
          }
          let _startTimes =  _createStartTimes(blocks, editor_width)
          setStartTimes(_startTimes)

          // 分割
          let chunk_start = 0
          let chunk_arr = []
          let chunks = []
          let chunk_duration = 0
          for ( let i=0; i<_startTimes.length; i++ ) {

            let _item = _startTimes[i]
            let _time_for_next = _item.time_for_next

            if (chunk_start === -1) {
              chunk_start = _item.start
            }

            chunk_duration = _item.end - chunk_start

            // console.log("chunk_duration: ", chunk_duration)
            // console.log("_item: ", _item)

            chunk_arr.push(_item)

            if (_time_for_next !== 0 && !_time_for_next) {
              continue
            }

            let new_arrau = false
            if (chunk_duration > THRESH1_DURATION && _time_for_next > THRESH1_PAUSE) {
              new_arrau = true
            } else if (chunk_duration > THRESH2_DURATION && _time_for_next > THRESH2_PAUSE) {
              new_arrau = true
            } else if (chunk_duration > THRESH3_DURATION) {
              new_arrau = true
            }
            if (new_arrau === true) {

              chunks.push({
                '_id': chunk_arr[0].key,
                'duration': chunk_duration,
                'list1': chunk_arr,
                'start_index': chunk_arr[0].index,
              })
              console.log("chunk_arr: ", chunk_arr)

              chunk_arr = []

              chunk_start = -1
            }
          }

          // add last chunk here
          chunks.push({
            '_id': chunk_arr[0].key,
            'duration': chunk_duration,
            'list1': chunk_arr,
            'start_index': chunk_arr[0].index,
          })
          chunk_arr = []
          chunk_start = -1

          // create draftjs ...
          for (let i=0; i<chunks.length; i++) {

            let item = chunks[i]
            let list1 = item.list1
            let keys = []
            for (let j=0; j<list1.length; j++) {
              if (keys.indexOf(list1[j].key) === -1) {
                keys.push(list1[j].key)
              }
            }

            let chunk_blocks = []

            for ( let j=0; j<blocks.length; j++ ) {
              let item2 = blocks[j]

              if (keys.indexOf(item2.key) !== -1) {
                chunk_blocks.push(item2)
              }
            }

            let _draftjs = {
              'blocks': chunk_blocks,
              'entityMap': transcript_draftjs_raw.entityMap,
            }

            chunks[i].draftjs = _draftjs
          }

          // console.log("chunks: ", chunks)

          let chunks2 = []
          for (let i=0; i<chunks.length; i++) {
            let _chunk = chunks[i]

            let _blocks = _chunk.draftjs.blocks

            let _blockText = ""
            for ( let j=0; j<_blocks.length; j++ ) {
              _blockText = _blockText + _blocks[j]
            }
            _blockText = _blockText.trim()

            if (_blockText) {
              chunks2.push(_chunk)
              editorRefs.current.push(React.createRef())
            }
          }

          setChunkByTimeList(chunks2)
        }


      } else if (type === "restore") {

        console.log("-- restore --")

        // fixed
        if (results_1.blocks_str_fixed) {

          // blocks_str_fixed
          let blocks_and_times_fixed = JSON.parse(results_1.blocks_str_fixed)

          let blocks_all = []

          let idx = 0
          let chunks = []
          for (let i=0; i<blocks_and_times_fixed.length; i++) {

            let item = blocks_and_times_fixed[i]
            let blocks = item.blocks
            let entityMap = item.entityMap
            let startTimes = item.startTimes
            console.log("startTimes: ", startTimes)


            // check if data exists
            let _blockText = ""
            for ( let j=0; j<blocks.length; j++ ) {
              let _block = blocks[j]

              let _text = _block.text
              if (!_text) {
                continue
              }
              _blockText = _blockText + _text
            }
            _blockText = _blockText.trim()
            if (!_blockText) {
              continue
            }

            // console.log(":blocks[0]L ", blocks[0])

            let _id = blocks[0].key
            let start_of_start = -1
            if (blocks[0].data) {
              start_of_start = blocks[0].data.start_time
            }
            let end_of_end = -1
            if (blocks[blocks.length-1].data) {
              end_of_end = blocks[blocks.length-1].data.end_time
            }

            let duration = end_of_end - start_of_start

            // console.log("duration: ", duration)

            let _draftjs = {
              'blocks': blocks,
              'entityMap': entityMap,
            }

            blocks_all = blocks_all.concat(blocks)

            chunks.push({
              draftjs: _draftjs,
              list1: startTimes,
              _id: _id,
              // dration: duration,
              start_index : startTimes[0].index,
            })

            // let editorRef = useRef(null)
            editorRefs.current.push(React.createRef())
          }

          // get start times
          // let _startTimes = _createStartTimes(blocks_all)

          // create start times
          let editor_width = 730
          if (widthRef.current) {
            editor_width = widthRef.current.offsetWidth
          }
          let _startTimes =  _createStartTimes(blocks_all, editor_width)
          console.log("all --  ", _startTimes)
          setStartTimes(_startTimes)

          // set chunk
          console.log("chunks: ", chunks)

          setChunkByTimeList(chunks)
        }
      }

      if (results_1.checked) {
        setNaranciaChecked(results_1.checked)
      }

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }

  let _pauseMedia2 = () => {
    setIsPlaying(false)
    // playerRef.current.setAudioTimestamp(playerCurrentTime-1.0)
  }

  let _playMedia2 = () => {
    setIsPlaying(true)
  }

  // toggle play media
  let _togglePlayMediaFromWord = ({
    start_time,
    end_time,
  }) => {

    console.log("_togglePlayMediaFromWord:")

    if (mediaType === "audio") {

      if (!playerRef || !playerRef.current) {
        return
      }

      if (isPlaying === false) {

        playerRef.current.setAudioTimestamp(start_time)
        playerRef.current.playAudio()

        setIsPlaying(true)

      } else {

        playerRef.current.pauseAudio()
        setIsPlaying(false)
      }


    } else if (mediaType === "video") {


      if (!videoPlayerRef || !videoPlayerRef.current) {
        return
      }

      if (isPlaying === false) {

        // playerRef.current.setAudioTimestamp(start_time)
        // playerRef.current.playAudio()

        videoPlayerRef.current.seek(start_time)
        videoPlayerRef.current.play()

        setIsPlaying(true)

      } else {

        // playerRef.current.pauseAudio()
        videoPlayerRef.current.pause()
        setIsPlaying(false)
      }

    }
  }

  let _stopPlayMediaFromWord = () => {

    if (mediaType === "audio") {

      playerRef.current.pauseAudio()
      setIsPlaying(false)

    } else if (mediaType === "video") {

      videoPlayerRef.current.pause()
      setIsPlaying(false)

    }

  }

  // toggle play media
  let _togglePlayMediaChunk = async (item, download_flg) => {

    console.log("_togglePlayMediaChunk.startTimes: ", item, download_flg )

    if (!playerRef || !playerRef.current) {
      return
    }

    if (isPlaying === false) {

      // key
      let _selectedBlockKey = item.key
      console.log("_togglePlayMediaChunk._selectedBlockKey", _selectedBlockKey)

      if (!editorRefs.current) {
        throw Error("no such editors")
      }

      let _selectedEntityMap = {}
      let _blockItem = null
      for (let i=0; i<editorRefs.current.length; i++) {

        if (!editorRefs.current[i].current) {
          continue
        }

        let _raw = editorRefs.current[i].current.getRaw()
        let _blocks = _raw.blocks
        let _entityMap = _raw.entityMap

        for (let j=0; j<_blocks.length; j++) {
          let _block = _blocks[j]

          if (_block.key === _selectedBlockKey) {

            _blockItem = _block
            _selectedEntityMap = _entityMap

            break
          }
        }
        if (_blockItem) {
          break
        }
      }
      console.log("_blockItem: ", _blockItem)

      let _startAndEnds = []

      let _inlineStyleRanges = _blockItem.inlineStyleRanges
      let _entityRanges = _blockItem.entityRanges

      for ( let i=0; i<_inlineStyleRanges.length; i++ ) {

        let _item = _inlineStyleRanges[i]

        if (_item.style === "STRIKETHROUGH") {

          let _styleOffset = _item.offset
          let _styleLength = _item.length

          let _entityKeys = []

          for (let j=0; j<_entityRanges.length; j++) {

            let _range = _entityRanges[j]

            let _range_end = _range.offset + _range.length
            let _styleEnd = _styleOffset + _styleLength

            // type 1
            if ( _range.offset <= _styleOffset ) {
              if ( _range_end >= _styleOffset) {
                // ok
                _entityKeys.push(_range.key)
              }
            } else {
              if (_range.offset <= _styleEnd) {
                // ok
                _entityKeys.push(_range.key)
              }
            }
          }

          // start entity key to end entity key
          console.log("_entityKeys: ", _entityKeys)

          let _firstKey = _entityKeys[0]
          let _lastKey = _entityKeys[_entityKeys.length-1]

          let _firstEntity = _selectedEntityMap[_firstKey]
          let _lastEntity = _selectedEntityMap[_lastKey]

          _startAndEnds.push({
            start: _firstEntity.data.start,
            end: _lastEntity.data.end
          })

        }
      }
      //
      console.log("_startAndEnds: ", _startAndEnds)
      console.log("_selectedEntityMap: ", _selectedEntityMap)

      let _start = item.start
      let _audioChunks = []

      for (let i=0; i<_startAndEnds.length; i++) {

        _audioChunks.push({
          start: _start,
          end: _startAndEnds[i].start
        })

        _start = _startAndEnds[i].end
      }
      // add last parts
      if (_start !== item.end) {
        _audioChunks.push({
          start: _start,
          end: item.end,
        })
      }

      setIsPlaying(true)

      playerRef.current.setAudioTimestamp(item.start)
      let wav = await _createShortAudioFromTimestamps(_audioChunks)

      // download_flg
      console.log("download_flg: ",download_flg)

      if (download_flg === true) {

        let element = document.createElement('a');
        element.href = URL.createObjectURL(wav)
        // element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(fileContent));
        element.setAttribute('download', 'my-audio.wav');

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);

        _transcribe2(wav)

        setIsPlaying(false)

      } else {

        // new blob url
        let _blobUrl2 = URL.createObjectURL(wav)

        shortAudio.src = _blobUrl2
        shortAudio.play()

        shortAudio.onended = () => {
          setIsPlaying(false)
          // playerRef.current.setAudioTimestamp(end_time)
        }

        shortAudio.addEventListener("timeupdate", () => {
          let time = shortAudio.currentTime;
          // setPlayerCurrentTime(time+start_time)
        });
      }

    } else {

      shortAudio.pause()

      playerRef.current.setAudioTimestamp(item.start+shortAudio.currentTime)

      // playerRef.current.pauseAudio()
      // playerRef.current.setAudioTimestamp(playerCurrentTime-1.0)
      setIsPlaying(false)
    }
  }




  // create short audio from timestamps
  let _createShortAudioFromTimestamps = async (audioChunks) => {


    // get blob
    let _url = mediaUrl
    let _blob = await fetch(_url).then(response => response.blob());

    // blob to array buffer
    let _arrayBuffer = await _blob.arrayBuffer()

    // create audio context
    const audioContext = new AudioContext()

    // array buffer to audio buffer
    let _audioBuffer = await getAudioBufferFromArrayBuffer(_arrayBuffer)
    let sampleRate = _audioBuffer.sampleRate
    let _channelData = _audioBuffer.getChannelData(0)

    // get part of channel data
    // let part_of_audio_array = []

    // get duration
    // let _duration = 0
    let total_duration = 0
    for ( let i=0; i<audioChunks.length; i++ ) {

      let _item = audioChunks[i]

      let _start = audioChunks[i].start
      let _end = audioChunks[i].end

      // _start = parseFloat(parseFloat(_start).toFixed(2))
      // _end = parseFloat(parseFloat(_end).toFixed(2))

      let _part_of_channelData = _channelData.slice(_start*sampleRate, _end*sampleRate)

      // total_duration = total_duration + _part_of_channelData.length
      total_duration = total_duration + _part_of_channelData.length

      // _duration = _duration + (_end - _start)
    }
    // // adding 0.01 is something we need to re-think
    // _duration = parseFloat(parseFloat(_duration+0.01).toFixed(2))


    console.log("==== total_duration: ", total_duration)
    // console.log("sampleRate * _duration: ", sampleRate * _duration)
    //

    // edit audio buffer
    let myAudioBuffer = audioContext.createBuffer(1, total_duration, sampleRate);

    let myAudioFloat32Array = myAudioBuffer.getChannelData(0);

    console.log("")
    console.log("")

    // get part of channel data
    let _current_len = 0
    for ( let i=0; i<audioChunks.length; i++ ) {

      console.log("-- i -- ", i)

      let _item = audioChunks[i]
      let _start = audioChunks[i].start
      let _end = audioChunks[i].end

      _start = parseFloat(parseFloat(_start).toFixed(2))
      _end = parseFloat(parseFloat(_end).toFixed(2))

      let _part_of_channelData = _channelData.slice(_start*sampleRate, _end*sampleRate)

      if (i === 0) {

        // console.log("_duration: ", _duration)
        console.log("_current_len: ", _current_len)
        console.log("_part_of_channelData: ", _part_of_channelData.length)

        myAudioFloat32Array.set(_part_of_channelData)

        // _current_len = _current_len + _part_of_channelData.length

      } else {

        // console.log("_duration: ", _duration)
        // console.log("sampleRate * _duration: ", sampleRate * _duration)
        console.log("_current_len: ", _current_len)
        console.log("_part_of_channelData: ", _part_of_channelData.length)

        if ( total_duration < _part_of_channelData.length + _current_len ) {
          console.log("_part_of_channelData.length + _current_len: ", _part_of_channelData.length + _current_len)
        }

        myAudioFloat32Array.set(_part_of_channelData, _current_len)
      }

      _current_len = _current_len + _part_of_channelData.length

      console.log("111 _current_len: ", _current_len)
    }

    console.log("")
    console.log("")

    // audio buffer to array buffer
    let myArrayBuffer = myAudioFloat32Array.buffer

    // get WAV file bytes and audio params of your audio source
    const wavBytes = getWavBytes(myAudioFloat32Array.buffer, {
      isFloat: true,       // floating point or 16-bit integer
      numChannels: 1,
      sampleRate: sampleRate,
    })

    // convert audio buffer to array buffer
    const blob2 = new Blob([wavBytes], {type : 'audio/wav'});

    return blob2
  }







  // _createShortAudioAndPlay
  let _createShortAudioAndPlay = async ({
    start_time,
    end_time,
  }) => {


    console.log("NaranciaTest._createShortAudioAndPlay: " )

    let _duration = end_time - start_time

    let _url = mediaUrl

    // blob
    let _blob = await fetch(_url).then(response => response.blob());
    console.log("_blob: ", _blob)
    console.log("_type: ", _blob.type)
    console.log("_size: ", _blob.size)

    // blob to array buffer
    let _arrayBuffer = await _blob.arrayBuffer()
    console.log("_arrayBuffer: ", _arrayBuffer)

    const audioContext = new AudioContext()

    // array buffer to audio buffer
    let _audioBuffer = await getAudioBufferFromArrayBuffer(_arrayBuffer)
    console.log(_audioBuffer)

    let sampleRate = _audioBuffer.sampleRate

    let _channelData = _audioBuffer.getChannelData(0)
    console.log("_channelData: ", _channelData.length )

    let _part_of_channelData = _channelData.slice(start_time*sampleRate, end_time*sampleRate)
    console.log("_part_of_channelData: ", _part_of_channelData.length)

    // create new audio buffer
    let audioCtx = new AudioContext()

    // let myAudioBuffer = audioCtx.decodeAudioData(_part_of_channelData)
    // console.log("myAudioBuffer: ", myAudioBuffer)

    // edit audio buffer
    let myAudioBuffer = audioCtx.createBuffer(1, sampleRate * _duration, sampleRate);

    let myAudioFloat32Array = myAudioBuffer.getChannelData(0);
    myAudioFloat32Array = _part_of_channelData
    console.log("myAudioBuffer: ", myAudioBuffer)

    // audio buffer to array buffer
    let myArrayBuffer = myAudioFloat32Array.buffer
    console.log("myAudioFloat32Array.buffer: ", myAudioFloat32Array.buffer)


    // get WAV file bytes and audio params of your audio source
    const wavBytes = getWavBytes(myAudioFloat32Array.buffer, {
      isFloat: true,       // floating point or 16-bit integer
      numChannels: 1,
      sampleRate: sampleRate,
    })
    console.log("wavBytes: ", wavBytes)


    // convert audio buffer to array buffer
    const blob2 = new Blob([wavBytes], {type : 'audio/wav'});
    console.log("blob2: ", blob2)

    // new blob url
    let _blobUrl2 = URL.createObjectURL(blob2)

    // // play audio
    // let _audio = new Audio()
    //
    // _audio.src = _blobUrl2
    // _audio.play()
    //
    // _audio.addEventListener("timeupdate", () => {
    //   let time = _audio.currentTime;
    //   setPlayerCurrentTime(time+start_time)
    // });

    shortAudio.src = _blobUrl2
    shortAudio.play()

    shortAudio.onended = () => {
      setIsPlaying(false)
      playerRef.current.setAudioTimestamp(end_time)
    }

    shortAudio.addEventListener("timeupdate", () => {
      let time = shortAudio.currentTime;
      setPlayerCurrentTime(time+start_time)
    });
  }



  // wait a second
  let _wait = ({ msec }) => {
    return new Promise((resolve, reject) => {
      setTimeout(() =>{
        resolve()
      }, msec);
    })
  }

  // startTimes
  // react-video subscribe state change
  useEffect(() => {

    if (!playerRef.current) {
      return
    }

    for (let i=0; i<startTimes.length; i++) {
      let _item = startTimes[i]
      let _start = _item.start
      let _end = _item.end
      let _index = _item.index

      // console.log("playerCurrentTime ", playerCurrentTime)
      // console.log("_start: ", _start)
      // console.log("_end: ", _end)

      if (playerCurrentTime > _start && playerCurrentTime < _end) {
        setPlayingBlockIndex(_index)
        break
      }
    }

  }, [playerCurrentTime]);


  // save fix
  let _saveFix = async () => {

    setLoading(true)

    try {

      let urlSearchParams = new URLSearchParams(window.location.search);
      let params = Object.fromEntries(urlSearchParams.entries());
      let narancia_id = params._id
      if (!narancia_id) {
        throw Error("no narancia_id detected.")
      }

      //
      if (!editorRefs.current) {
        throw Error("no such editors")
      }

      let _startTimes_diff = 0

      let blocks_and_times_fixed = []
      for (let i=0; i<editorRefs.current.length; i++) {

        // console.log("editorRefs.current[i].current: ", editorRefs.current[i].current)

        if (!editorRefs.current[i].current) {
          continue
        }

        let _raw = editorRefs.current[i].current.getRaw()
        let _blocks = _raw.blocks
        let _entityMap = _raw.entityMap
        let _startTimes = editorRefs.current[i].current.getStartTimes()

        // console.log(i , "_blocks: ", _blocks)
        console.log("_startTimes.0: ", _startTimes)

        // for (let j=0; j<_startTimes.length; j++) {
        //   _startTimes[j].index = _startTimes[j].index + _startTimes_diff
        // }
        // _startTimes_diff = _startTimes.length

        // console.log("_startTimes.1: ", _startTimes)

        for (let j=0; j<_blocks.length; j++) {
          let _block = _blocks[j]
          // console.log("_block: ", _block)
          let _inlineStyleRanges = _block.inlineStyleRanges
          // console.log("_inlineStyleRanges: ", _inlineStyleRanges)
          let _inlineStyleRanges2 = []
          for (let k=0; k<_inlineStyleRanges.length; k++) {
            if (_inlineStyleRanges[k].style.startsWith("REALTIME") !== true) {
              _inlineStyleRanges2.push(_inlineStyleRanges[k])
            }
          }
          _blocks[j].inlineStyleRanges = _inlineStyleRanges2
        }

        blocks_and_times_fixed.push({
          blocks: _blocks,
          entityMap: _entityMap,
          startTimes: _startTimes,
        })
      }

      // return;

      let blocks_str = JSON.stringify(blocks_and_times_fixed)

      // get evaluation masters
      const results_1 = await MyAPI.updateNaranciaOne({
        login_token: login_token,
        narancia_id: narancia_id,
        blocks_str_fixed: blocks_str,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      console.log("updateNaranciaOne.results_1: ", results_1)

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }


  // // _editorStateUpdated
  // let _editorStateUpdated = () => {
  //
  //   if (!editorRef.current) {
  //     return
  //   }
  //
  //   // re-create start times list
  //   let blocks =  editorRef.current.getBlocks()
  //   _createStartTimes(blocks)
  //
  //   // let _blockTimes = _prepareBlockTimes()
  // }

  // // create start times list for blocks data
  // let _createStartTimes = (blocks) => {
  //
  //   let editor_width = 730
  //   if (widthRef.current) {
  //     editor_width = widthRef.current.offsetWidth
  //   }
  //
  //   // let chunk_duration = 0
  //   let _start_times = []
  //
  //   for ( let i=0; i<blocks.length; i++ ) {
  //
  //     let _block = blocks[i]
  //     let _key = _block.key
  //     let _text = _block.text
  //
  //     let _time0 = ""
  //     if (_block.data && _block.data.time0 ){
  //       _time0 = _block.data.time0
  //     }
  //
  //     if (_time0) {
  //
  //       let _str0 = _time0.split("___")[0]
  //       let _str1 = _str0.split("@")[0]
  //       let _start = parseFloat(parseFloat(_str1.split("~")[0]).toFixed(2))
  //       let _end = parseFloat(parseFloat(_str1.split("~")[1]).toFixed(2))
  //       let _duration = _end - _start
  //       _duration = parseFloat(parseFloat(_duration).toFixed(2))
  //
  //       // console.log("_time0: ", _time0)
  //       // console.log("_str0: ", _str0)
  //       // console.log("_start: ", _start)
  //
  //       if (_str1 !== "dummy") {
  //
  //         _start_times.push({
  //           index: i,
  //           type: "text",
  //           key: _key,
  //           start: _start,
  //           end: _end,
  //           duration: _duration,
  //         })
  //
  //       } else {
  //
  //         _start_times.push({
  //           index: i,
  //           type: "dummy",
  //           key: _key,
  //           start: "",
  //           end: "",
  //           duration: "",
  //         })
  //
  //       }
  //
  //       // calculate width
  //       let _span = document.createElement('span');
  //       // _span.setAttribute("style", "font-size: 20px;");
  //       _span.setAttribute("style", "font-size: 1rem;");
  //       // _span.setAttribute("style", "font-size: 1rem; height:"+editor_width-17.13+";");
  //       _span.innerText = _text
  //       document.body.appendChild(_span);
  //       let _span_w = _span.getBoundingClientRect().width
  //       document.body.removeChild(_span);
  //
  //       let line_count = Math.ceil(_span_w / (editor_width-6) )
  //       if (_key === "b3016c9e1634a5c9cc544b82dd59272b684fbc3a9b7c29dc2b0c35715130bedf") {
  //         console.log("line_count: ", line_count, _text, _span_w, editor_width-6)
  //       }
  //
  //       if (line_count > 1) {
  //         for (let j=0; j<line_count-1; j++) {
  //
  //           _start_times.push({
  //             index: i,
  //             type: "multi_line",
  //             key: _key+j,
  //             start: "",
  //             end: "",
  //             duration: "",
  //           })
  //         }
  //       }
  //
  //     } else {
  //
  //       // console.log("222_start: ")
  //
  //       _start_times.push({
  //         index: i,
  //         type: "unknown",
  //         key: _key,
  //         start: "",
  //         end: "",
  //         duration: "",
  //       })
  //     }
  //   }
  //
  //   // get dration between...
  //   let last_end = 0
  //   for (let i=0; i<_start_times.length; i++) {
  //     let item = _start_times[i]
  //
  //     if (item.type !== "text") {
  //       continue
  //     }
  //
  //
  //     if (item.start !== 0 && !item.start) {
  //       continue
  //     }
  //     let duration2 = item.start - last_end
  //     // console.log(item.type, " duration2: ", duration2)
  //     _start_times[i]['time_for_next'] = parseFloat(duration2).toFixed(2)
  //     last_end = item.end
  //   }
  //
  //   setStartTimes(_start_times)
  //
  //   return _start_times
  // }

  // // _updateStart
  // let _updateStart = (item) => {
  //
  // }

  // highlight modified words
  let _showModifiedWords = async () => {

    console.log("_showModifiedWords111")

    // fixed
    let current_texts = ""

    // console.log("editorRefs.current: ", editorRefs.current)

    for (let i=0; i<editorRefs.current.length; i++) {

      let _raw = editorRefs.current[i].current.getRaw()
      let _blocks = _raw.blocks

      for ( let j=0; j<_blocks.length; j++) {
        let _block = _blocks[j]
        let _text = _block.text
        current_texts = current_texts + _text + " "
      }
    }
    // console.log("current_texts: ", current_texts)


    // original
    let original_texts = ""
    for ( let i=0; i<transcriptDraftjsRaw.blocks.length; i++ ) {
      let _block = transcriptDraftjsRaw.blocks[i]
      let _text = _block.text
      original_texts = original_texts + _text + " "
    }
    original_texts = original_texts.trim()

    if (current_texts === original_texts) {
      _showAlert("コンテンツは編集されていません", "info")
      return;
    }

    console.log("_showModifiedWords.1")

    let chunks = []

    // create
    for (let i=0; i<editorRefs.current.length; i++) {
      let _raw = editorRefs.current[i].current.getRaw()
      let _blocks = _raw.blocks

      console.log("_showModifiedWords.2")

      let keys = []
      for (let j=0; j<_blocks.length; j++) {
        let _block = _blocks[j]
        keys.push(_block.key)
      }

      console.log("keys: ", keys)

      // chunk_blocks_default
      let chunk_blocks_default = []


      for (let j=0; j<transcriptDraftjsRaw.blocks.length; j++) {

        let _block = transcriptDraftjsRaw.blocks[j]
        // console.log("_block: ", _block)

        if ( keys.indexOf(_block.key) !== -1 ) {
          chunk_blocks_default.push(_block)
        }
      }

      console.log("_showModifiedWords.3 ", chunk_blocks_default)

      // create change highlighted
      let new_draftjs = await _createChangeHighlightedDraftJs(_blocks, chunk_blocks_default)

      console.log("_blocks: ", _blocks)
      console.log("chunk_blocks_default: ", chunk_blocks_default)

      let _startTimes = chunkByTimeList[i].list1
      let _id = chunkByTimeList[i]._id
      let _duration = chunkByTimeList[i]._duration

      chunks.push({
        draftjs: new_draftjs,
        list1: _startTimes,
        _id: _id,
        dration: _duration,
      })

      // break
    }

    setChunkByTimeList(chunks)
  }


  // create change highlighted
  let _createChangeHighlightedDraftJs = async ( modified, original ) => {

    // current

    let current_draftjs = {
      'blocks': modified,
      'entityMap': {},
    }

    let draftjs_fixed = {}
    let fixed_obj1 = {}
    let last_start1 = 0
    if (current_draftjs) {

      draftjs_fixed = current_draftjs

      let _blocks = draftjs_fixed.blocks

      for (let i=0; i<_blocks.length; i++) {
        let _block = _blocks[i]

        let _texts = _block.text
        // sentence_fixed = sentence_fixed + _texts

        let _time0 = ""
        if (_block.data && _block.data.time0) {
          _time0 = _block.data.time0
        }
        if (_time0) {
          let _arr1 = _time0.split("___")
          for ( let j=0; j<_arr1.length; j++ ) {

            let _str1 = _arr1[j]
            let _arr2 = _str1.split("@")
            let _time_key = _arr2[0]
            let _start = parseFloat(_time_key.split("~")[0])
            let _end = parseFloat(_time_key.split("~")[1])
            let _range = _arr2[1]
            let _range0 = parseInt(_range.split("-")[0])
            let _range1 = parseInt(_range.split("-")[1])

            if (_start <= last_start1) {
              continue
            }

            if ( !fixed_obj1[_time_key] ) {
              fixed_obj1[_time_key] = {
                start: _start,
                end: _end,
                texts: _texts.substr(_range0, _range1)
              }
            } else {
              fixed_obj1[_time_key].texts = fixed_obj1[_time_key].texts + _texts.substr(_range0, _range1)
            }

            last_start1 = _start
          }
        }
      }
    }


    let draftjs_ai = {
      'blocks': original,
      'entityMap': {},
    }


    let default_obj1 = []
    let last_start2 = 0

    let _blocks = draftjs_ai.blocks

    for (let i=0; i<_blocks.length; i++) {
      let _block = _blocks[i]

      let _texts = _block.text

      let _time0 = ""
      if (_block.data && _block.data.time0) {
        _time0 = _block.data.time0
      }
      if (_time0) {
        let _arr1 = _time0.split("___")
        for ( let j=0; j<_arr1.length; j++ ) {

          let _str1 = _arr1[j]
          let _arr2 = _str1.split("@")
          let _time_key = _arr2[0]
          let _start = parseFloat(_time_key.split("~")[0])
          let _end = parseFloat(_time_key.split("~")[1])
          let _range = _arr2[1]
          let _range0 = parseInt(_range.split("-")[0])
          let _range1 = parseInt(_range.split("-")[1])

          if (_start < last_start2) {
            continue
          }


          if ( !default_obj1[_time_key] ) {
            default_obj1[_time_key] = {
              start: _start,
              end: _end,
              texts: _texts.substr(_range0, _range1)
            }
          } else {
            default_obj1[_time_key].texts = default_obj1[_time_key].texts + _texts.substr(_range0, _range1)
          }

          last_start2 = _start
        }
      }
    }


    let missed_obj1 = {}

    // fixed_obj1
    for ( let key in fixed_obj1 ) {

      let _item_fixed = fixed_obj1[key]
      let _texts_fixed = _item_fixed.texts

      // let _item_default = null
      let _texts_default = ""
      if ( default_obj1[key] ) {
        let _item_default = default_obj1[key]
        _texts_default = _item_default.texts
      }

      // diff
      let _diffs = Diff.diffChars(_texts_fixed, _texts_default)

      for ( let i=0; i<_diffs.length; i++ ) {
        let _item2 = _diffs[i]
        if (_item2.removed === true) {
          // console.log("_item2: ", _item2.value)

          if (!missed_obj1[key]) {
            missed_obj1[key] = []
          }
          missed_obj1[key].push(_item2.value)
        }
      }
    }

    // list of fixed draftjs blocks objects
    let fixed_list1 = []
    for ( let key in fixed_obj1 ) {

      let _item = fixed_obj1[key]

      fixed_list1.push({
        key: key,
        start: _item.start,
        end: _item.end,
        texts: _item.texts,
      })
    }

    // get trimmed_words
    let trimmed_words = await _checkWord(missed_obj1, fixed_list1)

    // prepare fixed_obj2
    for ( let i=0; i<fixed_list1.length; i++ ) {

      let _item = fixed_list1[i]
      let _texts = _item.texts
      let _key = _item.key

      if ( trimmed_words[_key] ) {

        for (let j=0; j<trimmed_words[_key].length; j++) {

          let _word = trimmed_words[_key][j]

          let _results = _texts.match(_word)
          if (_results) {

            if (!fixed_list1[i].inlineStyleRanges) {
              fixed_list1[i].inlineStyleRanges = []
            }

            // add
            fixed_list1[i].inlineStyleRanges.push({
              length: _word.length,
              offset: _results.index,
              style: 'HIGHLIGHT_DICT',
            })
          }
        }
      }
    }

    draftjs_fixed.blocks = fixed_list1

    let draftjs_for_dict = {
      'blocks': [],
      'entityMap': {},
    }

    for (let i=0; i<fixed_list1.length; i++) {

      let _item = fixed_list1[i]
      let _key = _item.key
      let _texts = _item.texts
      let _start = _item.start
      let _end = _item.end
      let _inlineStyleRanges = _item.inlineStyleRanges

      draftjs_for_dict.blocks.push({
        'data': {
          time0: _start+"~"+_end+"@0-"+_texts.length,
        },
        'entityRanges': [],
        'inlineStyleRanges': _inlineStyleRanges,
        'key': Math.random().toString(16).slice(2),
        'text': _texts,
        'type': 'unstyled',
      })
    }

    // update
    // console.log("draftjs_for_dict: ", draftjs_for_dict)

    // setTranscriptDraftjsAI(draftjs_for_dict)
    return draftjs_for_dict
  }


  // _checkWord
  let _checkWord = async (fixed_words, fixed_list1) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.checkPotentialDictVocab({
        fixed_words: fixed_words,
        fixed_blocks: fixed_list1,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      setLoading(false)

      if (results_1.trimmed_words) {
        return results_1.trimmed_words
      }

    } catch (err) {
      console.log("err: ", err )

      _showAlert(err.message, "error")

      setLoading(false)
    }
  }

  // add _addVocabs
  let _addVocabsToCustomDictonary = async () => {

    setLoading(true)

    try {

      // let draftjs_obj =  editorRef.current.getRaw()


      let blocks_all = []
      for (let i=0; i<editorRefs.current.length; i++) {
        let _raw = editorRefs.current[i].current.getRaw()
        let _blocks = _raw.blocks

        blocks_all = blocks_all.concat(_blocks)
      }


      let _draftjs = {
        'blocks': blocks_all,
        'entityMap': {},
      }

      // get evaluation masters
      const results_1 = await MyAPI.addVocabsToCustomDictonary({
        draftjs_obj: _draftjs,
        login_token: login_token,
        api_key_id: apiKeyToAdd,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      _showAlert("辞書登録成功", "success")

      // props.getVocabListAgain(props.apiIdSelected)

    } catch (err) {
      console.log("err: ", err )

      _showAlert(err.message, "error")
    }

    setLoading(false)
  }

  // _toggleChckMark
  let _toggleChckMark = async () => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.narantiaToggleChecked({
        narancia_id: naranciaId,
        login_token: login_token,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      if (results_1.checked) {
        setNaranciaChecked(results_1.checked)
      }

    } catch (err) {
      console.log("err: ", err )
      _showAlert(err.message, "error")
    }

    setLoading(false)
  }

  let _toggleEditMode = (item, idx) => {
    console.log("_toggleEditMode.")

  }


  // re-create chunks
  let _reCreateChunks = ({
    word,
    blockKey,
    end_time,
    start_time,
    position,
    offset,
  }) => {

    if (!editorRefs.current) {
      throw Error("no such editors")
    }

    let _chunks = []

    let blocks_and_times_fixed = []

    // let movingWord = word+" "
    let justDetected = false
    let _movingEntity = null

    for (let i=0; i<editorRefs.current.length; i++) {

      let _raw = editorRefs.current[i].current.getRaw()
      let _blocks = _raw.blocks
      let _entityMap = _raw.entityMap

      // TBD: need to fix!
      let _startTimes = editorRefs.current[i].current.getStartTimes()

      console.log("_entityMap: ", _entityMap)
      console.log("_startTimes: ", _startTimes)
      console.log("_blocks: ". _blocks)
      // return;

      let _blocks2 = []

      for ( let j=0; j<_blocks.length; j++ ) {

        let _block = _blocks[j]

        if (justDetected === true && position === "end") {

          console.log("0 block.entityRanges: ", _block.entityRanges)

          console.log("0 end _movingEntity: ",  _movingEntity)

          // _block.text = word + " " + _block.text
          _block.text = word + _block.text

          _movingEntity.offset = 0

          let _entityRanges2 = []
          _entityRanges2.push(_movingEntity)

          for (let k=0; k<_block.entityRanges.length; k++) {
            let _item = _block.entityRanges[k]
            _item.offset = _item.offset + _movingEntity.length
            _entityRanges2.push(_item)
          }

          // console.log("1 end _movingEntity2: ",  _movingEntity2)

          // _block.entityRanges.splice(0, 0, _movingEntity2)
          _block.entityRanges = _entityRanges2

          // console.log("1 block._movingEntity2: ", _block.entityRanges)
          // _movingEntity = _movingEntity2

          // diff
          let _diff = end_time - start_time

          _startTimes[j].duration = _startTimes[j].duration + _diff
          _startTimes[j].start = start_time

          justDetected = false

        } else if ( justDetected === true && position === "start" ) {
          // _blocks[]

          let _offset = _blocks[j-2].text.length

          _blocks[j-2].text = _blocks[j-2].text + word

          // diff
          let _diff = end_time - start_time

          _startTimes[j-2].duration = _startTimes[j].duration + _diff
          _startTimes[j-2].end = end_time



          console.log("_blocks[j-2]: ", _blocks[j-2])

          console.log("_blocks[j-2].entityRanges: ", _blocks[j-2].entityRanges)


          // _movingEntity.offset = 0

          // let _entityRanges2 = []
          // _entityRanges2.push(_movingEntity)
          _movingEntity.offset = _offset
          _blocks[j-2].entityRanges.push(_movingEntity)


          justDetected = false
        }

        if ( _block.key === blockKey ) {

          // remove from entityRanges
          if (position === "end") {

            _movingEntity = _block.entityRanges.pop()
            _block.text = _block.text.substr(0, offset-1)

            // diff
            let _diff = end_time - start_time

            _startTimes[j].duration = _startTimes[j].duration - _diff
            _startTimes[j].end = end_time

          } else if (position === "start") {

            _movingEntity = _block.entityRanges.shift()
            _block.text = _block.text.substr(_movingEntity.length)

            console.log("_block.entityRanges: ", _block.entityRanges)
            let _entityRanges2 = []

            for (let k=0; k<_block.entityRanges.length; k++) {
              let _item = _block.entityRanges[k]
              _item.offset = _item.offset - _movingEntity.length
              _entityRanges2.push(_item)
            }

            // diff
            let _diff = end_time - start_time

            _startTimes[j].duration = _startTimes[j].duration - _diff
            _startTimes[j].start = end_time

          }

          justDetected = true
        }

        _blocks2.push(_block)
      }

      // unique key
      let _id = _blocks2[0].key

      let _textall = ""

      // let _startTimes2 = []

      for ( let j=0; j<_blocks2.length; j++ ) {
        let _block = _blocks2[j]

        let _text = _block.text
        if (!_text) {
          continue
        }
        _textall = _textall + _text
      }

      if (!_textall) {
        continue
      }

      let _draftjs = {
        'blocks': _blocks2,
        'entityMap': _entityMap,
      }

      _chunks.push({
        draftjs: _draftjs,
        list1: _startTimes,
        _id: _id,
      })

    }

    setChunkByTimeList(_chunks)
  }





  // send audio to api server directly...
  let _transcribe2 = async (myBlob) => {

    // props.setLoading(true)

    try {

      // dictinary is applied automatically
      let _mini_dict = []

      let api_key = apiKey
      let api_url = "https://asr1.shabelab.com/transcribe"

      if (!api_key || !api_url) {
        props.showAlert("api key not deteced.", "error")
        return;
      }

      // myBlob
      let base64 = await _convertBlob2Base64(myBlob)
      let results = await _transcribeBase64(api_key, api_url, base64, _mini_dict)

      console.log("results: ", results)

      // props.showAlert("OK", "success")

    } catch (err) {
      console.log("err: ", err )

      // props.showAlert(err.message, "error")
    }

    // props.setLoading(false)
  }


  // convert blob into base64
  let _convertBlob2Base64 = (blob) => {

    return new Promise(function(resolve, reject) {

      var reader = new FileReader();
      reader.readAsArrayBuffer(blob)

      reader.onloadend = function() {
        var data = reader.result;
        let _buffer = new Buffer(data);
        resolve(_buffer.toString("base64"))
      }

    })
  }

  // transcribe local file
  let _transcribeBase64 = async (api_key, api_url, audio_base64, mini_dictionary) => {

    try {

      let results_1 = await axios.post(api_url, {
        audio: audio_base64,
        response_type: 'v2',
        stereo: false,
        get_timestamps: false,
        mini_dictionary: mini_dictionary,
      }, {
        headers: {
          'Accept': 'application/json',
          'Authorization': api_key,
        },
      })
      let _results_2 = null
      if (results_1.data) {
        _results_2 = results_1.data
      }

      if (_results_2.status !== 'success') {
        throw Error(_results_2.message)
      }

      let _results_3 = _results_2.results

      return _results_3

    } catch (err) {
      throw Error(err.message)
    }
  }



  // react-video

  // _playerOnEnd
  let _playerOnEnd = () => {

  }

  // reference for player
  let videoPlayerRef = useRef(null)

  // save fix and create video ...
  let _saveFixAndCreateVideo = async () => {

    try {

      // // save fix
      // await _saveFix()

      // create new video...
      let urlSearchParams = new URLSearchParams(window.location.search);
      let params = Object.fromEntries(urlSearchParams.entries());
      let narancia_id = params._id
      if (!narancia_id) {
        throw Error("no narancia_id detected.")
      }


      // get evaluation masters
      let results_1 = await MyAPI.createNewNaranciaVideo({
        login_token: login_token,
        narancia_id: narancia_id,
      })

      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      let _videoUrl = await results_1.video_url
      console.log("_videoUrl: ", _videoUrl)

      setTmpVideoUrl(_videoUrl)

    } catch (err) {
      console.log("err: ", err)
    }
  }






  return (
    <div>

      <Header />

      <NaranciaSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
        minHeight: 300,
      }}>

        <Row style={{
          // backgroundColor: '#cccccc',
          marginTop: 10,
          marginBottom: 10,
        }}>

          <Col md="2" xs="12" />
          <Col md="8" xs="12" style={{
            textAlign: 'left',
            backgroundColor: '#ffffff',
            padding: 20,
          }}>
            <span>{naranciaId}</span>

            <FontAwesomeIcon
              onClick={() => _toggleChckMark()}
              icon="check"
              style={{
                cursor: 'pointer',
                marginLeft: 10,
                marginRight: 10,
                color: naranciaChecked === true ? 'green' : '#777777',
            }}/>

          </Col>
          <Col md="2" xs="12" />
        </Row>



        <Row style={{
          // backgroundColor: '#cccccc',
          marginTop: 10,
          marginBottom: 10,
        }}>

          <Col md="2" xs="12" />
          <Col md="8" xs="12" style={{
            textAlign: 'left',
            backgroundColor: '#ffffff',
            padding: 20,
          }}>

            {chunkList.map((item, idx) => (

              <Link key={item._id} to={"/narancia_view?chunk_id="+item._id} style={{
                textDecoration: 'none',
                color: '#ffffff',
              }}>

                <span style={{
                  marginRight: 2,
                  marginLeft: 2,
                  backgroundColor: '#cccccc',
                  padding: 4,
                  fontSize: 10,
                }}>{idx}</span>

              </Link>
            ))}

          </Col>
          <Col md="2" xs="12" />
        </Row>

        {/* transcribe and restore buttons  */}
        { chunkByTimeList.length === 0 && (
          <Row style={{
            // backgroundColor: '#cccccc',
            marginTop: 10,
            marginBottom: 10,
          }}>

            <Col md="2" xs="12" />
            <Col className="shadow2dp" md="8" xs="12" style={{
              textAlign: 'left',
              backgroundColor: '#ffffff',
              padding: 20,
            }}>

              <InputGroup>

                <InputGroupText style={{
                  backgroundColor: '#ffffff',
                  borderStyle: 'none',
                }}>

                  <span onClick={() => _transcript('restore')} style={{
                    marginRight: 10,
                    cursor: 'pointer',
                    backgroundColor: '#cccccc',
                    fontSize: 14,
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 8,
                    paddingRight: 8,
                    borderRadius: 2,
                  }}>
                    Restore
                  </span>


                  <span style={{
                    marginLeft: 10,
                    marginRight: 10,
                  }}>
                    |
                  </span>

                </InputGroupText>

                <Input
                  type="password"
                  name='api_key_input'
                  onChange={(e) => setApiKey(e.target.value)}
                  value={apiKey}
                  placeholder='API key' />

                <InputGroupText onClick={() => _transcript('trnscribe')} style={{
                  cursor: 'pointer',
                }}>
                  Transcript!
                </InputGroupText>

              </InputGroup>

            </Col>
            <Col md="2" xs="12" />
          </Row>
        ) }


        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>

          <Col md="12" xs="12" style={{
            textAlign: 'center',
          }}>

            {mediaType === "audio" && mediaUrl && (
              <div style={{
                position: 'relative',
                width: '100%',
                top: 160,
                right: 10,
              }}>
                <AudioController
                  pauseMedia={_pauseMedia2}
                  playMedia={_playMedia2}
                  setPlayerCurrentTime={setPlayerCurrentTime}
                  ref={playerRef}
                  mediaUrl={mediaUrl} />
              </div>
            )}

            {mediaType === "video" && videoUrl && (
              <div className="shadow2dp" style={{
                position: 'fixed',
                width: 300,
                top: 100,
                right: 100,
                zIndex: 10,
              }}>

                <Player
                  onEnded={_playerOnEnd}
                  ref={videoPlayerRef}
                  playsInline={true}
                  src={videoUrl} >
                   <BigPlayButton position="center" />
                </Player>

              </div>
            )}

            {mediaType === "video" && tmpVideoUrl && (
              <div className="shadow2dp" style={{
                position: 'fixed',
                width: 300,
                top: 300,
                right: 100,
                zIndex: 10,
              }}>

                <Player
                  playsInline={true}
                  src={tmpVideoUrl} >
                   <BigPlayButton position="center" />
                </Player>

              </div>
            )}

          </Col>
        </Row>


        {/* calculate width */}
        <Row>
          <Col md="2" xs="12" />
          <Col md="8" xs="12">
            <div ref={widthRef} style={{
              width: '100%',
              height: 1,
            }} />
          </Col>
          <Col md="2" xs="12" />
        </Row>

        {/* editor block  */}
        <Row style={{
          marginTop: 5,
          marginBottom: 40,
        }}>
          <Col md="12" xs="12">

            {chunkByTimeList.map((item, idx) => (
              <NaranciaEditorBlock
                idx={idx}
                ref={editorRefs.current[idx]}
                isPlaying={isPlaying}
                saveFix={_saveFix}
                toggleEditMode={_toggleEditMode}
                togglePlayMediaChunk={_togglePlayMediaChunk}
                togglePlayMediaFromWord={_togglePlayMediaFromWord}
                stopPlayMediaFromWord={_stopPlayMediaFromWord}
                showAlert={_showAlert}
                playerCurrentTime={playerCurrentTime}
                setIsPlaying={setIsPlaying}
                playingBlockIndex={playingBlockIndex}
                reCreateChunks={_reCreateChunks}
                key={item._id}
                item={item} />
            ))}

          </Col>
        </Row>


        {/* submit button */}
        <Row style={{
          marginTop: 20,
          marginBottom: 0,
        }}>
          <Col md="2" xs="12" />
          <Col md="8" xs="12" style={{
            textAlign: 'right',
          }}>

            {mediaType === "video" && (
              <FontAwesomeIcon
                onClick={_saveFixAndCreateVideo}
                icon="magic"
                style={{
                  cursor: 'pointer',
                  marginLeft: 10,
                  marginRight: 10,
                  color: '#777777',
              }}/>
            )}

            <FontAwesomeIcon
              onClick={_saveFix}
              icon="save"
              style={{
                cursor: 'pointer',
                marginLeft: 10,
                marginRight: 10,
                color: '#777777',
            }}/>




          {/*<FontAwesomeIcon
              onClick={_showModifiedWords}
              icon="hand-pointer"
              style={{
                cursor: 'pointer',
                marginLeft: 10,
                marginRight: 10,
                color: '#777777',
            }}/>*/}

          </Col>

          <Col md="2" xs="12" />
        </Row>

        {/*<Row style={{
          marginTop: 20,
          marginBottom: 60,
        }}>
          <Col md="2" xs="12" />
          <Col md="8" xs="12">

            <InputGroup>
              <Input
                style={{
                  height: '100%',
                }}
                type="texts"
                name={"key_to_add"}
                value={apiKeyToAdd}
                onChange={(e) => setApiKeyToAdd(e.target.value)} />
              <InputGroupText
                onClick={_addVocabsToCustomDictonary}
                style={{
                cursor: 'pointer',
                fontSize: 12,
              }}>
                <span>
                  Add vocabs to API Key
                </span>
              </InputGroupText>
            </InputGroup>

          </Col>

          <Col md="2" xs="12" />
        </Row>*/}

      </Container>

      <br/>

      {/* footer */}
      <Footer />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

      {/* modal */}
      {/*<EditEditorModal
        updateEditorByKey={_updateEditorByKey}
        item={editorItem}
        toggleEditMode={_toggleEditMode}
        isOpen={showEditEditor} />*/}

    </div>
  )
}

export default NaranciaAnnotationSplit
